module.exports = __webpack_public_path__ + "img/buildyourown_mob_v2.44e169f.svg";